import { ElementType } from 'react';
import URL from '@/finsight/Router/urlConstants';
import IconPrice from '@dealroadshow/uikit/core/components/Icon/IconPrice';
import IconLayersGroup from '@dealroadshow/uikit/core/components/Icon/IconLayersGroup';

export interface ILinkConfig {
  url: string,
  dataTest: string,
  label: string,
  IconLink?: ElementType,
}

const linksConfig: ILinkConfig[] = [
  {
    url: URL.PRICING,
    dataTest: 'pricing',
    IconLink: IconPrice,
    label: 'Pricing',
  },
  {
    url: URL.SOLUTIONS,
    dataTest: 'solutions',
    IconLink: IconLayersGroup,
    label: 'Solutions',
  },
];

export default linksConfig;
